import { c as _c } from "react/compiler-runtime";
export default function DropListItemContentGroupMention() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="tw-align-middle tw-font-medium tw-text-primary-400">@all</span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}